import { render, staticRenderFns } from "./AlertsFilter.vue?vue&type=template&id=2190d097&scoped=true&"
import script from "./AlertsFilter.vue?vue&type=script&lang=js&"
export * from "./AlertsFilter.vue?vue&type=script&lang=js&"
import style0 from "./AlertsFilter.vue?vue&type=style&index=0&id=2190d097&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2190d097",
  null
  
)

export default component.exports